import XAPPService from './XAPPService.js';

export default XAPPService;
